import { LocalDbMessages } from "./messages";
import { LocalDbSettings } from "./settings";
import { LocalDbAudio } from "./audio";
import { LocalDbCrud } from "./crud";
import { LocalDbEvents } from "./events";

class LocalDb {
  messages: LocalDbMessages;
  settings: LocalDbSettings;
  audio: LocalDbAudio;
  glstate: LocalDbCrud<any>;
  cache: LocalDbCrud<any>;
  cache_api: LocalDbCrud<any>;
  events: LocalDbEvents;

  constructor(db: IDBDatabase) {
    this.messages = new LocalDbMessages(db);
    this.settings = new LocalDbSettings(db);
    this.audio = new LocalDbAudio(db);
    this.glstate = new LocalDbCrud(db, "glstate");
    this.cache = new LocalDbCrud(db, "cache");
    this.cache_api = new LocalDbCrud(db, "cache_api");
    this.events = new LocalDbEvents(db);
    // this.NEW_TABLE_NAME = new LocalDbCrud(db, "NEW_TABLE_NAME");
  }
}

const tables: {
  name: string;
  options?: IDBObjectStoreParameters;
  indices?: {
    name: string;
    keyPath: string | Iterable<string>;
    options?: IDBIndexParameters;
  }[];
}[] = [
  {
    name: "settings",
  },
  {
    name: "messages",
    options: {
      keyPath: "id",
      autoIncrement: true,
    },
    indices: [
      {
        name: "key_idx",
        keyPath: "key",
        options: { unique: true },
      },
    ],
  },
  {
    name: "audio",
  },
  {
    name: "glstate",
  },
  {
    name: "cache",
  },
  {
    name: "cache_api",
  },
  {
    name: "events",
    indices: [
      {
        name: "session_guid",
        keyPath: "session_guid",
      },
    ],
  },
];

export default new Promise<LocalDb>((resolve, reject) => {
  const request: IDBOpenDBRequest = indexedDB.open("ocas_client", 1);
  request.onupgradeneeded = function () {
    const db: IDBDatabase = request.result;
    tables.forEach((table) => {
      if (!db.objectStoreNames.contains(table.name)) {
        const objectStore = db.createObjectStore(table.name, table.options);
        table.indices?.forEach((index) => {
          objectStore.createIndex(index.name, index.keyPath, index.options);
        });
      }
    });
  };
  request.onerror = function () {
    reject(new Error("Database connection error"));
  };
  request.onsuccess = function () {
    resolve(new LocalDb(request.result));
  };
});
